// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2eVLP","error":"Textarea_error__yfAL_","readonly":"Textarea_readonly__2RxAF","disabled":"Textarea_disabled__3AZ-_"};